//@flow

import {
  createProductOptionGroupApi,
  deleteProductOptionGroupApi,
  updateProductOptionGroupApi,
  listProductOptionGroupsApi,
  listProductOptionGroupOptionsApi,
  endpoints,
  getProductOptionGroupSettingsApi,
} from '../api';
import {buildRoute} from '../../../http';

import type {
  StoreProductOptionGroup,
  StoreProductOption,
  CreateStoreProductOptionGroupRequest,
  UpdateStoreProductOptionGroupRequest,
} from '../../../entities/product-option';
import type {PaginationRequest, PaginationResponse} from '../../../entities';

export function listProductOptionGroupsService(
  params: PaginationRequest
): Promise<PaginationResponse<StoreProductOptionGroup>> {
  return listProductOptionGroupsApi(params).toPromise();
}

export function createProductOptionGroupService(
  request: CreateStoreProductOptionGroupRequest
): Promise<StoreProductOptionGroup> {
  return createProductOptionGroupApi(request).toPromise();
}

export function updateProductOptionGroupService(
  storeProductOptionGroupId: string,
  request: UpdateStoreProductOptionGroupRequest
): Promise<StoreProductOptionGroup> {
  const route = buildRoute(endpoints.UPDATE_PRODUCT_OPTION_GROUP, [
    storeProductOptionGroupId,
  ]);
  return updateProductOptionGroupApi(request, {route}).toPromise();
}

export function deleteProductOptionGroupService(
  storeProductOptionGroupId: string
): Promise<void> {
  const route = buildRoute(endpoints.DELETE_PRODUCT_OPTION_GROUP, [
    storeProductOptionGroupId,
  ]);
  return deleteProductOptionGroupApi({route}).toPromise();
}

export function listProductOptionGroupOptionsService(
  storeProductOptionGroupId: string
): Promise<StoreProductOption[]> {
  const route = buildRoute(endpoints.LIST_PRODUCT_OPTION_GROUP_OPTIONS, [
    storeProductOptionGroupId,
  ]);
  return listProductOptionGroupOptionsApi(undefined, {route}).toPromise();
}

export function getProductOptionGroupSettingsService(
  productId: string
): Promise<ProductOptionGroupSettings> {
  const route = buildRoute(endpoints.GET_PRODUCT_OPTION_GROUP_SETTINGS, [
    productId,
  ]);
  return getProductOptionGroupSettingsApi(undefined, {
    route,
  }).toPromise();
}
